import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { PARTNER_WHITELIST_STATUS } from './types';
import { getPartnerWhitelistStatus } from '../../api';

export const fetchPartnerWhitelistStatus =
  (orgId: number) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const partnerWhitelistStatus = getPartnerWhitelistStatus(orgId, state);
    dispatch(thunkProgress(PARTNER_WHITELIST_STATUS, partnerWhitelistStatus));
  };
